'use strict';

import {keys} from 'ts-transformer-keys';

import User from '~/shared/src/model/User';

export type AllowedUserAttributes = Pick<User,
    // properties
    'userId'
    | 'name'
    | 'firstName'
    | 'lastName'
    | 'email'
    | 'language'
    | 'applicationName'
    | 'groupMemberships'
    | 'verified'
    | 'setupCompleted'
    // methods
    | 'isMemberOfGroup'
    | 'hasPermissionOnItemType'
    | 'hasGenericPermissionOnItemType'
    | 'hasPermissionOnPropertySet'
    | 'hasGenericPermissionOnPropertySet'
    | 'hasPermissionOnReferenceSet'
    | 'hasGenericPermissionOnReferenceSet'
    | 'hasPermissionOnReferencePropertySet'
    | 'hasGenericPermissionOnReferencePropertySet'
>;

export const allowedUserAttributes = keys<AllowedUserAttributes>() as string[];
type AllowedUserAttributesTypes = User[ 'userId' ] | User[ 'firstName' ] | User[ 'lastName' ] | User[ 'email' ] | User[ 'language' ] | User[ 'applicationName' ] | User[ 'groupMemberships' ] | User[ 'isMemberOfGroup' ];

class UserTemplateStringResolver {
    protected _user : User | undefined;

    constructor( user? : User ) {
        this._user = user;

        return new Proxy( this, this );
    }

    get( user : UserTemplateStringResolver, attribute : Symbol ) : ( () => string );
    get( user : UserTemplateStringResolver, attribute : keyof AllowedUserAttributes ) : AllowedUserAttributesTypes;
    get( user : UserTemplateStringResolver, attribute : Symbol | keyof AllowedUserAttributes ) : ( () => string ) | AllowedUserAttributesTypes {
        let retVal : ( () => string ) | AllowedUserAttributesTypes = '';

        if ( typeof attribute === 'symbol' ) {
            if ( attribute === Symbol.toPrimitive ) {
                retVal = () => {
                    return 'user';
                };
            }
        }
        else if ( this._user && typeof attribute === 'string' ) {
            if ( allowedUserAttributes.includes( attribute ) ) {
                // bind the user as scope to relayed functions
                if ( typeof this._user[ attribute ] === 'function' ) {
                    retVal = ( this._user[ attribute ] as Function ).bind( this._user );
                }
                else {
                    retVal = this._user[ attribute ] as AllowedUserAttributesTypes;
                }
            }
        }
        else {
            retVal = `user.${attribute}`;
        }

        return retVal;
    }
}

export default UserTemplateStringResolver;
